module.exports = __webpack_public_path__ + "media/images/home/produto_chuva_sample-70284e2daac20ccd60d5eadbb3d80a5e.png";